// Einheitliche Darstellung von Beträgen und Daten in den Admin-Masken.
//
// Beträge liegen in der DB durchgehend in Rappen. Bisher stand in den Listen
// `total / 100` — aus 1250 wurde „12.5 CHF" statt „CHF 12.50". Daten wurden
// mal per `createdAt.split('T')[0]` (ISO), mal per toLocaleDateString('de-DE'),
// mal per 'de-CH' formatiert.

const chfFormatter = new Intl.NumberFormat('de-CH', {
  style: 'currency',
  currency: 'CHF',
  minimumFractionDigits: 2,
});

const dateFormatter = new Intl.DateTimeFormat('de-CH', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const dateTimeFormatter = new Intl.DateTimeFormat('de-CH', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const dateTimeSecondsFormatter = new Intl.DateTimeFormat('de-CH', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

const EMPTY = '—';

/** Rappen → „CHF 12.50". */
export const formatChf = (rappen) => {
  const value = Number(rappen);
  if (!Number.isFinite(value)) return EMPTY;
  return chfFormatter.format(value / 100);
};

const toDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** ISO-String → „13.09.2026". */
export const formatDate = (value) => {
  const date = toDate(value);
  return date ? dateFormatter.format(date) : EMPTY;
};

/** ISO-String → „13.09.2026, 14:05". */
export const formatDateTime = (value) => {
  const date = toDate(value);
  return date ? dateTimeFormatter.format(date) : EMPTY;
};

/** ISO-String → „13.09.2026, 14:05:09" (Audit-Log). */
export const formatDateTimeSeconds = (value) => {
  const date = toDate(value);
  return date ? dateTimeSecondsFormatter.format(date) : EMPTY;
};

/** ISO-String → „2026-09-13" für <input type="date"> und <time dateTime>. */
export const toDateInputValue = (value) => {
  const date = toDate(value);
  return date ? date.toISOString().split('T')[0] : '';
};
